import { heroBig, sideFeeds, hotRank } from "@/mocks/guaData";

export default function Hero() {
  return (
    <section className="bg-paper-50">
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-6 md:px-6 md:pt-9">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-2 flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-500" />
              今日头版 · 编辑部精选
            </div>
            <h1 className="font-serif text-3xl font-extrabold tracking-tight text-stone-900 md:text-4xl">
              把每一个热搜，讲成一条看得懂的时间线
            </h1>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-stone-500">
            从发酵到反转再到落幕，{heroBig.category}栏目用公开信息梳理事件脉络，让吃瓜这件事更清晰、更克制、更有营养。
          </p>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* 头条大图 */}
          <article className="group lg:col-span-2">
            <a
              href="#story"
              className="block cursor-pointer overflow-hidden rounded-lg border border-paper-200 bg-white"
            >
              <div className="relative h-60 overflow-hidden md:h-80">
                <img
                  src={heroBig.image}
                  alt={heroBig.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 flex items-center gap-2 md:left-4 md:top-4">
                  <span className="rounded-md bg-primary-500 px-2.5 py-1 text-xs font-semibold text-white">
                    {heroBig.category}
                  </span>
                  <span className="rounded-md bg-black/45 px-2.5 py-1 text-xs font-medium text-white backdrop-blur">
                    <i className="ri-time-line mr-1" />
                    {heroBig.readTime}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-6">
                <h2 className="font-serif text-xl font-bold leading-snug text-stone-900 transition group-hover:text-primary-700 md:text-2xl">
                  {heroBig.title}
                </h2>
                <p className="mt-2.5 text-sm leading-relaxed text-stone-600">{heroBig.lead}</p>
                <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
                  <div className="flex flex-wrap items-center gap-4 text-xs text-stone-500">
                    <span><i className="ri-play-list-2-line mr-1 text-primary-500" />回放梳理 {heroBig.stats.replay}</span>
                    <span><i className="ri-discuss-line mr-1 text-primary-500" />讨论 {heroBig.stats.reply}</span>
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-800">
                      {heroBig.stats.heat}
                    </span>
                  </div>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600">
                    查看完整脉络 <i className="ri-arrow-right-line transition group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            </a>
          </article>

          {/* 右侧：热榜 + 新瓜速递 */}
          <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-paper-200 bg-white p-4">
              <div className="mb-3 flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-serif text-base font-bold text-stone-900">
                  <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 text-white"><i className="ri-fire-line" /></span>
                  实时热榜
                </h3>
                <a href="#hot" className="text-xs text-primary-600 hover:underline">榜单详情 <i className="ri-arrow-right-up-line" /></a>
              </div>
              <ol className="divide-y divide-paper-100">
                {hotRank.slice(0, 4).map((it, i) => (
                  <li key={it.title} className="flex items-start gap-3 py-2.5">
                    <span className={`mt-0.5 font-serif text-lg font-extrabold ${i === 0 ? "text-primary-500" : "text-stone-300"}`}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <a href="#hot" className="line-clamp-2 cursor-pointer text-sm leading-snug text-stone-700 transition hover:text-primary-700">
                        {it.title}
                      </a>
                      <div className="mt-1 flex items-center gap-2 text-[11px] text-stone-400">
                        <span className="text-accent-600"># {it.tag}</span>
                        <span>{it.heat}万</span>
                      </div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg border border-paper-200 bg-white p-4">
              <h3 className="mb-1 flex items-center gap-2 font-serif text-base font-bold text-stone-900">
                <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-white"><i className="ri-bubble-chart-line" /></span>
                今日话题速递
              </h3>
              <ul className="mt-3 space-y-3">
                {sideFeeds.map((f) => (
                  <li key={f.title} className="group flex items-start gap-3">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-300" />
                    <div className="min-w-0">
                      <a href="#channel" className="line-clamp-2 cursor-pointer text-sm leading-snug text-stone-700 transition group-hover:text-primary-700">
                        {f.title}
                      </a>
                      <div className="mt-1 flex items-center gap-2 text-[11px] text-stone-400">
                        <span className="rounded-full bg-primary-50 px-1.5 py-px font-medium text-primary-600">{f.tag}</span>
                        <span>{f.time}</span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}